(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vr-outfit-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-outfit-offer')) {
    customElements.define('vr-outfit-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          const form = document.getElementById(this.dataset.formId);
          const shirt = this.querySelector('select').value;
          const status = this.querySelector('[role="status"]');
          const button = this.querySelector('button');
          if (!form || !shirt) { status.textContent = this.dataset.error; return; }
          if (!form.reportValidity()) return;
          const data = new FormData(form);
          const variant = data.get('id');
          const quantity = Number(data.get('quantity') || 1);
          const mainButton = form.querySelector('[type="submit"]');
          if (!variant || quantity < 1 || !Number.isInteger(quantity) || mainButton?.disabled) {
            status.textContent = this.dataset.error;
            return;
          }
          const mainItem = {id: variant, quantity};
          const properties = {};
          for (const [key, value] of data.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string') properties[match[1]] = value;
          }
          if (Object.keys(properties).length) mainItem.properties = properties;
          if (data.get('selling_plan')) mainItem.selling_plan = data.get('selling_plan');
          const original = button.textContent;
          button.disabled = true;
          button.textContent = this.dataset.busy;
          status.textContent = '';
          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({items: [mainItem, {id: shirt, quantity: 1}]})
            });
            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || this.dataset.error);
            }
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
            button.disabled = false;
            button.textContent = original;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vr-product-editorial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-delivery-window')) {
  customElements.define('vr-delivery-window', class extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.timer = setInterval(() => this.updateDates(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    updateDates() {
      const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      const base = Date.UTC(value('year'), value('month') - 1, value('day'));
      const start = new Date(base + 8 * 86400000);
      const end = new Date(base + 11 * 86400000);
      const format = date => new Intl.DateTimeFormat('en-GB', {timeZone:'UTC',day:'numeric',month:'long',...(start.getUTCFullYear() !== end.getUTCFullYear() ? {year:'numeric'} : {})}).format(date);
      const range = start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear() ? start.getUTCDate() + '–' + format(end) : format(start) + ' – ' + format(end);
      const target = this.querySelector('[data-delivery-dates]');
      if (target) target.textContent = range;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vr-sleep-mask-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-sleep-mask-bundle')) {
    customElements.define('vr-sleep-mask-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.querySelector('button').addEventListener('click', async () => {
          const form = document.getElementById(this.dataset.formId);
          const status = this.querySelector('[role="status"]');
          const button = this.querySelector('button');
          if (!form) { status.textContent = this.dataset.error; return; }
          if (!form.reportValidity()) return;
          const data = new FormData(form);
          const mapping = JSON.parse(this.querySelector('[data-variant-map]').textContent);
          const bundle = mapping[data.get('id')];
          const quantity = Number(data.get('quantity') || 1);
          const mainButton = form.querySelector('[type="submit"]');
          if (!bundle || !Number.isInteger(quantity) || quantity < 1 || mainButton?.disabled) {
            status.textContent = this.dataset.error;
            return;
          }
          const original = button.textContent;
          button.disabled = true;
          button.textContent = this.dataset.busy;
          status.textContent = '';
          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: {'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({items:[{id:bundle,quantity}]})
            });
            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || this.dataset.error);
            }
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
            button.disabled = false;
            button.textContent = original;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vr-trouser-outfit-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-trouser-outfit-offer')) {
    customElements.define('vr-trouser-outfit-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          const form = document.getElementById(this.dataset.formId);
          const trousers = this.querySelector('select').value;
          const status = this.querySelector('[role="status"]');
          const button = this.querySelector('button');
          if (!form || !trousers) { status.textContent = this.dataset.error; return; }
          if (!form.reportValidity()) return;
          const data = new FormData(form);
          const variant = data.get('id');
          const quantity = Number(data.get('quantity') || 1);
          const mainButton = form.querySelector('[type="submit"]');
          if (!variant || quantity < 1 || !Number.isInteger(quantity) || mainButton?.disabled) {
            status.textContent = this.dataset.error;
            return;
          }
          const mainItem = {id: variant, quantity};
          const properties = {};
          for (const [key, value] of data.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string') properties[match[1]] = value;
          }
          if (Object.keys(properties).length) mainItem.properties = properties;
          if (data.get('selling_plan')) mainItem.selling_plan = data.get('selling_plan');
          const original = button.textContent;
          button.disabled = true;
          button.textContent = this.dataset.busy;
          status.textContent = '';
          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({items: [mainItem, {id: trousers, quantity: 1}]})
            });
            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || this.dataset.error);
            }
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
            button.disabled = false;
            button.textContent = original;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
